// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"2039f5b4961b742b3495","883":"d5d3b7152e43221d8934"}[chunkId] + ".js";
};